import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * The ONE logged-out screen. Every gated page renders this instead of
 * an ad-hoc "please log in" block, so the shell, page title, message,
 * and gold CTA look identical everywhere:
 *
 *   <LoginGate title="Binders" message="Log in to manage your binder..." />
 *
 * `section` renders the gold-dotted subtitle like the logged-in
 * headers do. Styles are the shared ones (page-section-head,
 * requests-placeholder, cta-gold) - no CSS of its own.
 */
function LoginGate({ title, section, message }) {
    const navigate = useNavigate();
    return (
        <div className="requests-container">
            {title && (
                <header className="page-section-head">
                    <h1>
                        {title}
                        {section && <> <span className="page-section-current">{section}</span></>}
                    </h1>
                </header>
            )}
            <div className="requests-placeholder">
                <p>{message}</p>
                <button className="cta-gold" onClick={() => navigate('/auth')}>Log In / Sign Up</button>
            </div>
        </div>
    );
}

export default LoginGate;
